<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Declaração de Comparecimento"
    >
        <List
            v-if="isList"
            :data="data"
            @edit="handleEdit"
        />

        <Form
            v-if="isForm"
            :data="data"
            :model="model"
            :only-form="onlyForm"
            :impressao="impressao"
            @saved="saved"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                v-if="isList || onlyForm"
                @click="cancel"
            >
                Fechar
            </rkm-button>

            <template v-if="isList">
                <rkm-button
                    @click="print()"
                    :disabled="declaracoes.length === 0"
                >
                    Imprimir todos
                </rkm-button>

                <rkm-button
                    @click="handleCreate"
                    color="primary"
                >
                    Nova declaração
                </rkm-button>
            </template>

            <template v-if="isForm">
                <rkm-button
                    v-if="!onlyForm"
                    @click="layout = 'list'"
                >
                    Voltar
                </rkm-button>

                <rkm-button
                    @click="handleSave"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Enums.
import declaracaoComparecimentoTipo from '@/enums/pronto-atendimento/atendimento-medico/declaracaoComparecimentoTipo'

// Mixins.
import { repository, error, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

import moment from 'moment'

export default {
    components: { Form, List },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento.atendimentoMedico')
        }
    },
    data: () => ({
        layout: 'list',
        model: null,
        enums: { declaracaoComparecimentoTipo },
        onlyForm: false
    }),
    computed: {
        isForm() {
            return this.layout == 'form'
        },
        isList() {
            return this.layout == 'list'
        },
        declaracoes() {

            return this.data.form.declaracoesComparecimento.concat(this.data.model.declaracoesComparecimento)
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(create = false) {

            if (create) {

                this.onlyForm = true
                this.handleCreate()
            }
            else {

                this.layout = 'list'
            }

            this.$refs.RkmModal.show()
        },
        print() {

            const data = {
                atendimentoId: this.data.model.atendimentoId,
                pacienteId: this.data.form.paciente.id,
            }

            const dataPaciente = {
                ...data,
                declaracoes: this.declaracoes
                    .filter(d => d.tipoId == this.enums.declaracaoComparecimentoTipo.PACIENTE)
                    .map(item => isNaN(item.id)
                        ? {
                            documentoTipoId: item.documentoTipoId,
                            documentoNumero: item.documentoNumero,
                            motivo: item.motivo,
                            nome: item.nome,
                            de: moment(moment(item.dataDe).format('YYYY-MM-DD') + ' ' + item.horaDe).format('YYYY-MM-DD HH:mm'),
                            ate: moment(moment(item.dataAte).format('YYYY-MM-DD') + ' ' + item.horaAte).format('YYYY-MM-DD HH:mm'),
                        }
                        : { id: item.id }
                    )
            }

            const dataAcompanhante = {
                ...data,
                declaracoes: this.declaracoes
                    .filter(d => d.tipoId == this.enums.declaracaoComparecimentoTipo.ACOMPANHANTE)
                    .map(item => isNaN(item.id)
                        ? {
                            documentoTipoId: item.documentoTipoId,
                            documentoNumero: item.documentoNumero,
                            motivo: item.motivo,
                            nome: item.nome,
                            de: moment(moment(item.dataDe).format('YYYY-MM-DD') + ' ' + item.horaDe).format('YYYY-MM-DD HH:mm'),
                            ate: moment(moment(item.dataAte).format('YYYY-MM-DD') + ' ' + item.horaAte).format('YYYY-MM-DD HH:mm'),
                        }
                        : { id: item.id }
                    )
            }

            if (dataPaciente.declaracoes.length > 0) {

                this.setLoading()

                this.repositories.impressao.declaracaoComparecimentoPaciente(
                    null,
                    this.camelObjectKeysToSnakeRecursive(dataPaciente)
                )
                    .then(this.openPrinting)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            if (dataAcompanhante.declaracoes.length > 0) {

                this.setLoading()

                this.repositories.impressao.declaracaoComparecimentoAcompanhante(
                    null,
                    this.camelObjectKeysToSnakeRecursive(dataAcompanhante)
                )
                    .then(this.openPrinting)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        openPrinting(response) {

            const content = new Blob([response.data], { type: response.headers['content-type'] })
            const url = URL.createObjectURL(content)
            const link = document.createElement('a')

            link.href = url
            link.target = '_blank'
            link.click()

            URL.revokeObjectURL(url);
        },
        handleCreate() {
            this.model = {
                id: null,
                tipoId: null,
                nome: null,
                documentoNumero: null,
                documentoTipoId: null,
                dataDe: this.data.atendimentoId ? moment(this.data.form.data, 'DD/MM/YYYY') : null,
                horaDe: this.data.atendimentoId ? this.data.form.hora : null,
                dataAte: this.data.form.finalizado ? moment(this.data.form.dataDesfecho, 'DD/MM/YYYY') : null,
                horaAte: this.data.form.finalizado ? this.data.form.horaDesfecho : null,
                motivo: null,
                medicoId: null,
            }

            this.layout = 'form'
        },
        handleEdit(item) {
            this.model = Object.assign({}, {
                id: item.id,
                tipoId: item.tipoId,
                nome: item.nome,
                documentoNumero: item.documentoNumero,
                documentoTipoId: item.documentoTipoId,
                dataDe: item.dataDe,
                horaDe: item.horaDe,
                dataAte: item.dataAte,
                horaAte: item.horaAte,
                motivo: item.motivo,
            })

            this.layout = 'form'
        },
        handleSave() {
            this.$refs.Form.save()
        },
        saved() {

            if (this.onlyForm) {

                this.$refs.RkmModal.hide()

                this.$emit('save')
            }

            this.layout = 'list'
        },
    },
    mixins: [repository, error, stringCase],
    props: {
        data: { type: Object, required: true },
        impressao: { type: Boolean, default: false },
    },
}
</script>